module.exports = __webpack_public_path__ + "posture/static/img/translucence-bg.ec2a0b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/translucence-bg.png
// module id = now/
// module chunks = 1